import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.staging.seek.com',
    clientDomain: 'talent.staging.seek.com.au',
    clientId: 'F66zpHV5IB7u8pG4VS7P4lmJyDhv9h9n',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://talent.seek.com.au/contactus/',
    },
    siteName: siteNames.employer.seek.au,
    zone: getZoneFromSite(siteNames.employer.seek.au),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=talent_staging_seek_com_au.js.map